import { toast } from 'react-toastify'

import { type HttpClientConfig } from 'core/infra/http/HttpClient'

import { createAgnosticHttpClient } from 'auth/infra/createAgnosticHttpClient'

import { ShipmentRepository } from '../infra/ShipmentRepository'

export type UpdateProNumberFactoryDependencies = {
  shipmentRepository: ShipmentRepository
}

export function updateProNumberFactory({ shipmentRepository }: UpdateProNumberFactoryDependencies) {
  return async function updateProNumber(
    shipmentUUID: string,
    proNumber?: string,
    config?: Partial<HttpClientConfig>
  ) {
    try {
      return await shipmentRepository.updateProNumber(shipmentUUID, proNumber, config)
    } catch (error) {
      toast.error('Could not update pro number')

      throw new Error('Could not update pro number', {
        cause: error as Error,
      })
    }
  }
}

export function updateProNumber(
  shipmentUUID: string,
  proNumber?: string,
  config?: Partial<HttpClientConfig>
) {
  const httpClient = createAgnosticHttpClient()
  const shipmentRepository = new ShipmentRepository({ httpClient })
  const submit = updateProNumberFactory({ shipmentRepository })

  return submit(shipmentUUID, proNumber, config)
}
